var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PdfAnnotate',{ref:"pdfViewer",attrs:{"toolbar":_vm.toolbar,"src":_vm.pdf}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }